import { render, staticRenderFns } from "./SectionPanel.vue?vue&type=template&id=0432e02d&scoped=true"
import script from "./SectionPanel.vue?vue&type=script&lang=js"
export * from "./SectionPanel.vue?vue&type=script&lang=js"
import style0 from "./SectionPanel.vue?vue&type=style&index=0&id=0432e02d&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0432e02d",
  null
  
)

export default component.exports